import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function DashboardCollapsibleSection({
  eyebrow,
  title,
  description,
  icon = null,
  isOpen,
  onToggle,
  children,
  actions = null,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-start justify-between gap-4 p-4 text-left transition hover:bg-slate-50 dark:hover:bg-slate-800/70 sm:p-5 lg:p-6"
      >
        <div className="flex min-w-0 gap-3">
          {icon ? (
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
              {icon}
            </div>
          ) : null}

          <div className="min-w-0">
            {eyebrow ? (
              <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                {eyebrow}
              </p>
            ) : null}

            <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
              {title}
            </h2>

            {description ? (
              <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                {description}
              </p>
            ) : null}
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          {actions ? (
            <div
              onClick={(event) => event.stopPropagation()}
              className="hidden sm:block"
            >
              {actions}
            </div>
          ) : null}

          <span className="flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200">
            {isOpen ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </div>
      </button>

      {isOpen ? (
        <div className="border-t border-slate-200 p-4 dark:border-slate-800 sm:p-5 lg:p-6">
          {actions ? <div className="mb-4 sm:hidden">{actions}</div> : null}
          {children}
        </div>
      ) : null}
    </section>
  );
}